/** VH-312: the day the session was trained, else its planned day in this week (ISO date). */
export const sessionDate = (session, weekStart) => {
  if (session.actual_date) return session.actual_date
  if (!weekStart || !session.planned_day) return null
  const day = new Date(`${weekStart}T12:00:00`)
  day.setDate(day.getDate() + session.planned_day - 1)
  const pad = (n) => String(n).padStart(2, '0')
  return `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`
}
